import { render, staticRenderFns } from "./ConversationNavigation.vue?vue&type=template&id=0d475ba8&"
import script from "./ConversationNavigation.vue?vue&type=script&lang=js&"
export * from "./ConversationNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports